export enum WebMessageType {
	Contact = "Contact",
	Career = "Career",
}
